import { render, staticRenderFns } from "./CommonSearch.vue?vue&type=template&id=0846294a&scoped=true"
import script from "./CommonSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./CommonSearch.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CommonSearch.vue?vue&type=style&index=0&id=0846294a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0846294a",
  null
  
)

export default component.exports